"use client";

import React, { useEffect, useState } from "react";
import { LogOut, Monitor, Smartphone, Tablet } from "lucide-react";
import { authService } from "../../services/admin-auth/auth.service";
import { toast } from "react-toastify";
import css from './loggedin-devices.module.css';

function LoggedInDevices() {
  const [devices, setDevices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loggingOut, setLoggingOut] = useState(null);

  const fetchDevices = async () => {
    try {
      setLoading(true);
      const response = await authService.devices();
      setDevices(response.devices || []);
    } catch (error) {
      console.error("Failed to fetch devices:", error);
      toast.error("Failed to load devices");
    } finally {
      setLoading(false);
    }
  };

  const handleLogoutDevice = async (deviceId, deviceName) => {
    try {
      setLoggingOut(deviceId);
      await authService.logoutDevice(deviceId);
      toast.success(`Successfully logged out from ${deviceName}`);
      // Refresh the devices list
      await fetchDevices();
    } catch (error) {
      console.error("Failed to logout device:", error);
      toast.error("Failed to logout from device");
    } finally {
      setLoggingOut(null);
    }
  };

  const getDeviceIcon = (deviceName) => {
    const name = deviceName.toLowerCase();
    if (
      name.includes("mobile") ||
      name.includes("phone") ||
      name.includes("android") ||
      name.includes("ios")
    ) {
      return <Smartphone className={css.deviceIcon} />;
    } else if (name.includes("tablet") || name.includes("ipad")) {
      return <Tablet className={css.deviceIcon} />;
    } else {
      return <Monitor className={css.deviceIcon} />;
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  useEffect(() => {
    fetchDevices();
  }, []);

  if (loading) {
    return (
      <div className={css.container}>
        <h3 className={css.title}>
          {"Logged In Devices"}
        </h3>
        <div className={css.loadingContainer}>
          {[1, 2, 3].map((i) => (
            <div key={i} className={css.loadingItem}></div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className={css.container}>
      <h3 className={css.title}>
        {"Logged In Devices"}
      </h3>

      {devices.length === 0 ? (
        <div className={css.emptyState}>
          <Monitor className={css.emptyIcon} />
          <p className={css.emptyText}>{"No devices found"}</p>
        </div>
      ) : (
        <div className={css.devicesList}>
          {devices.map((device) => (
            <div key={device.id} className={css.deviceItem}>
              <div className={css.deviceInfo}>
                <div>
                  {getDeviceIcon(device.name)}
                </div>
                <div className={css.deviceDetails}>
                  <h4 className={css.deviceName}>{device.name}</h4>
                  <p className={css.deviceLastActive}>
                    {"Last active"}: {formatDate(device.updatedAt)}
                  </p>
                  <p className={css.deviceFirstLogin}>
                    {"First login"}: {formatDate(device.createdAt)}
                  </p>
                </div>
              </div>

              <button
                onClick={() => handleLogoutDevice(device.id, device.name)}
                disabled={loggingOut === device.id}
                className={css.logoutButton}
              >
                <LogOut className={css.logoutIcon} />
                {loggingOut === device.id ? "Logging out..." : "Logout"}
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default LoggedInDevices;
